import { v4 as uuidv4 } from 'uuid';

export const Utils = {
    /*
     * Example key
     * protected/user-identity-id/image.jpg
     */
    parseFileKey(key) {
        return {
            key: key.split('/')[2],
            identityId: key.split('/')[1],
            level: key.split('/')[0],
        };
    },

    /*
     * Example
     * fileType = image/png
     */
    generateFileKey(fileType) {
        return uuidv4() + '.' + fileType.split('/').pop();
    },

    camelCaseToTitle(string) {
        if (!string) return '';

        const result = string.replace(/([A-Z])/g, ' $1');

        return result.charAt(0).toUpperCase() + result.slice(1);
    },

    formatPrice(price) {
        if (!price) return '';

        return new Intl.NumberFormat('en-US').format(price);
    },

    formatPhoneNumber(value) {
        const newValueArr = value.replace(/[^\d]/g, '').split('');

        const firstPart = newValueArr.slice(0, 3).join('');
        const secondPart = newValueArr.slice(3, 6).join('');
        const thirdPart = newValueArr.slice(6, 10).join('');

        let newValue = '';
        newValue += firstPart ? `(${firstPart})` : '';
        newValue += secondPart ? ` ${secondPart}` : '';
        newValue += thirdPart ? `-${thirdPart}` : '';

        return newValue;
    },
};
